import styled from "@emotion/styled";

export const ExpressionPopoverRoot = styled.div`
  width: 350px;
`;
